export class GcpWorkspaceInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "customerBindingPrincipalSet",
            "baseName": "customerBindingPrincipalSet",
            "type": "string",
            "format": ""
        },
        {
            "name": "customerBindingPrincipalSetGke",
            "baseName": "customerBindingPrincipalSetGke",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpWorkspaceInfo.attributeTypeMap;
    }
    constructor() {
    }
}
